import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiDollarSign, FiTrendingUp, FiFileText, FiCalculator } = FiIcons;

const TaxSummaryCard = ({ title, amount, subtitle, icon, color, trend }) => {
  const formatCurrency = (value) => {
    return `₹${parseFloat(value || 0).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const getIcon = () => {
    switch (icon) {
      case 'sales': return FiTrendingUp;
      case 'tax': return FiCalculator;
      case 'cgst': return FiFileText;
      case 'sgst': return FiFileText;
      case 'igst': return FiFileText;
      default: return FiDollarSign;
    }
  };

  const getColorClasses = () => {
    switch (color) {
      case 'blue': return 'bg-blue-50 border-blue-200 text-blue-800';
      case 'green': return 'bg-green-50 border-green-200 text-green-800';
      case 'purple': return 'bg-purple-50 border-purple-200 text-purple-800';
      case 'orange': return 'bg-orange-50 border-orange-200 text-orange-800';
      case 'red': return 'bg-red-50 border-red-200 text-red-800';
      default: return 'bg-gray-50 border-gray-200 text-gray-800';
    }
  };

  const getIconBg = () => {
    switch (color) {
      case 'blue': return 'bg-blue-100';
      case 'green': return 'bg-green-100';
      case 'purple': return 'bg-purple-100';
      case 'orange': return 'bg-orange-100';
      case 'red': return 'bg-red-100';
      default: return 'bg-gray-100';
    }
  };

  const IconComponent = getIcon();

  return (
    <motion.div
      className={`relative rounded-xl p-6 border-2 ${getColorClasses()} hover:shadow-md transition-all duration-300`}
      whileHover={{ y: -2 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium mb-1">{title}</p>
          <p className="text-2xl font-bold mb-1">{formatCurrency(amount)}</p>
          {subtitle && (
            <p className="text-xs opacity-75">{subtitle}</p>
          )}
          {trend && (
            <div className={`flex items-center space-x-1 mt-2 text-xs ${
              trend.direction === 'up' ? 'text-green-600' : 'text-red-600'
            }`}>
              <SafeIcon 
                icon={trend.direction === 'up' ? FiIcons.FiArrowUp : FiIcons.FiArrowDown} 
                className="w-3 h-3" 
              />
              <span>{trend.value}</span>
            </div>
          )}
        </div>
        <div className={`w-12 h-12 rounded-lg ${getIconBg()} flex items-center justify-center`}>
          <SafeIcon icon={IconComponent} className="w-6 h-6" />
        </div>
      </div>
    </motion.div>
  );
};

export default TaxSummaryCard;